///<reference types="@types/googlemaps" />
import {AfterViewChecked, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, NgZone, OnInit, Output, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {Utilities} from '@shared/utilities/utilities.model';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MapsAPILoader} from '@agm/core';
import {PermissionService} from '@shared/service/permission.service';
import {AutoCompleteItemModel} from '@shared/components/autocomplete/autocomplete.component';
import {NgxPaginationConfig} from '@shared/models/ngx-pagination-config';
import {Place} from 'app/appointments/models/appointment.model';
import {PlaceRepair} from 'app/claims/claims-commons/models/appointment-repair.model';
import {UserV3Model} from '@shared/models/user-v-3.model';
import {Router} from '@angular/router';
import {ROOT_AUTHORITY, ROOT_CONTRACT_CLOSING_SP, ROOT_DELIVERY, ROOT_FLOTTA_POOL, ROOT_INVOICING, ROOT_LOGISTICS, ROOT_NOTIFICATION_CENTER, ROOT_TYRES, ROOT_USER_CHANGE_SP} from 'app/app-routing-roots';
import {AUTHORITY_DASHBOARD} from 'app/authority/authority-routing-roots';
import {CCSPO_DASHBOARD} from '@cc-sp-operator/cc-sp-routing-roots';
import {TYRES_OPC} from 'app/tyres/tyres-routing-roots';
import {TYRES_OPC_DASHBOARD} from 'app/tyres/opc/tyres-opc-routing-roots';
import {UC_DASHBOARD} from 'app/user-change/user-change-routing-roots';
import {LOGISTICS_OASR_DASHBOARD} from 'app/logistics/oasr/logistics-oasr-routing-roots';
import {SelectCommoditiesService} from '@shared/service/select-commodities.service';
import {CommodityModel} from '@shared/models/commodity.model';
import {NemoModuleKeys, UserPermissionsModel} from '@shared/models/user-permission.model';
import {Module, ModuleService} from '@shared/service/module.service';
import {InnerMessageAdministrationService} from 'app/administration/administration-shared/services/inner-message-administration.service';
import {TranslateContext} from '@shared/pipes/translate.pipe';
import {catchError} from 'rxjs/operators';
import {throwError} from 'rxjs';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {AppConfigEnvironmentService} from '@shared/service/appconfig-environment.service';
import {LOGISTICS_OPASR} from '../../../logistics/logistics-routing-roots';
import {INVOICING_DASHBOARD} from 'app/invoicing/invoicing-routing-roots';
import {NC_DASHBOARD} from '../../../notification-center/notification-center-routing-roots';
import {DL_DASHBOARD} from '../../../delivery/delivery-routing-roots';

export interface Range {
	label: string;
	value: number;
}

@Component(
	{
		selector: 'amd-find-centers',
		templateUrl: './find-centers.component.html',
		styleUrls: ['./find-centers.component.scss'],
		providers: [/*CentersService,*/ /*UsersService,*/ SelectCommoditiesService]
	}
)

export class FindCentersComponent implements OnInit, AfterViewChecked {

	static CENTER_CLASS_DEFAULT: string = 'amd-link amd-link--border amd-link--station';
	static CENTER_CLASS_SELECTED: string = 'amd-link amd-link--border amd-link--station amd-link--active';

	showLoader: boolean;
	saveLoader: boolean;
	selectedcomodities: CommodityModel[];
	// @Input() module: any;
	// @Input() profile: any;
	@Input() accordionDisabled: boolean = false;
	@Input() accordionExpanded: boolean = true;
	@Input() resetCenterSelected: boolean;
	@Input() placeDelivery: Place;
	@Output() setCenter: EventEmitter<PlaceRepair[]> = new EventEmitter<PlaceRepair[]>();
	@ViewChild('searchAddress') searchAddress: ElementRef;
	centersAccordionExpand: boolean = false;
	centerSelected: PlaceRepair = new PlaceRepair();
	translateContext: TranslateContext = TranslateContext.SHARED;

	paginator: NgxPaginationConfig = {
		itemsPerPage: 6,
		autoHide: true,
		previousLabel: '',
		nextLabel: '',
		screenReaderPageLabel: 'Paginazione',
		screenReaderCurrentLabel: 'Pagina',
		maxSize: 100,
	};
	paginator1: NgxPaginationConfig = {
		itemsPerPage: 6,
		autoHide: true,
		previousLabel: '',
		nextLabel: '',
		screenReaderPageLabel: 'Paginazione',
		screenReaderCurrentLabel: 'Pagina',
		maxSize: 100,
	};
	currentPage: number;
	currentPage1: number;
	mapItemsClasses: Map<string, string> = null;
	address: string;
	places: PlaceRepair[];
	placeSelected: PlaceRepair[];
	onceSelectedPlaces: PlaceRepair[] = [];
	searchControl: FormControl = new FormControl('', Validators.required);
	place: google.maps.LatLng;
	autocomplete: any;
	formIsValid: boolean = false;
	modelAutoComplete: string;
	currentUserPermission: UserPermissionsModel;

	listFormAutoComplete: AutoCompleteItemModel[];
	rangeValues: Range[] = [
		{label: '25km', value: 25000},
		{label: '50km', value: 50000},
		{label: '100km', value: 100000},
		{label: '200km', value: 200000},
	];
	rangeSelected: number = this.rangeValues[0].value;
	showSearchLoader: boolean = false;
	isSearchByAddress: boolean = true;
	searchForm: FormGroup;
	modules: typeof Module = Module;
	maxCommodities: number;

	get disableButton(): boolean {
		return this.isSearchByAddress ? (this.searchControl.invalid || !this.place) : this.searchForm.invalid;
	}

	constructor(
		public moduleService: ModuleService,
		private mapsAPILoader: MapsAPILoader,
		public permissionService: PermissionService,
		//public centerService: CentersService,
		public selectComoditiesService: SelectCommoditiesService,
		private ngZone: NgZone,
		public _dialog: MatDialog,
		public cdr: ChangeDetectorRef,
		private router: Router,
		public fb: FormBuilder,
		private changeDetector: ChangeDetectorRef,
		private InnerMessageAdmin: InnerMessageAdministrationService,
		private appConfig: AppConfigEnvironmentService
	) {
		this.maxCommodities = this.appConfig.Environment.MAX_COMMODITIES_NUMBER;
	}

	ngOnInit(): void {
		this.initForm();
		this.initPlaceAutocomplete();
	}

	ngAfterViewChecked(): void {
		this.changeDetector.detectChanges();
	}

	initForm(): void {
		this.searchForm = this.fb.group(
			{
				...{
					ald_commodity_id: [],
					name: [],
					municipality: [],
					region: [],
					page_size: [-1],
				},
				...this.moduleService.getCurrentModule() === Module.INVOICING ? {
					cod_axus: [],
					vat_number: []
				} : {}
			}
		);

		this.searchForm.valueChanges.subscribe(
			value => {
				if (
					this.moduleService.getCurrentModule() === Module.INVOICING ?
						!(
							(value.ald_commodity_id && value.ald_commodity_id !== '') ||
							(value.name && value.name !== '') ||
							(value.municipality && value.municipality !== '') ||
							(value.region && value.region !== '') ||
							(value.cod_axus && value.cod_axus !== '') ||
							(value.vat_number && value.vat_number !== '')
						)
						:
						!(
							(value.ald_commodity_id && value.ald_commodity_id !== '') ||
							(value.name && value.name !== '') ||
							(value.municipality && value.municipality !== '') ||
							(value.region && value.region !== '')
						)
				) {
					this.searchForm.get('ald_commodity_id').setErrors({fillOneField: true});
					this.searchForm.get('name').setErrors({fillOneField: true});
					this.searchForm.get('municipality').setErrors({fillOneField: true});
					this.searchForm.get('region').setErrors({fillOneField: true});

					if (this.moduleService.getCurrentModule() === Module.INVOICING) {
						this.searchForm.get('cod_axus').setErrors({fillOneField: true});
						this.searchForm.get('vat_number').setErrors({fillOneField: true});
					}
					Utilities.markFormGroupTouchedAndDirty(this.searchForm);
				} else {
					this.searchForm.get('ald_commodity_id').setErrors(null);
					this.searchForm.get('name').setErrors(null);
					this.searchForm.get('municipality').setErrors(null);
					this.searchForm.get('region').setErrors(null);

					if (this.moduleService.getCurrentModule() === Module.INVOICING) {
						this.searchForm.get('cod_axus').setErrors(null);
						this.searchForm.get('vat_number').setErrors(null);
					}

					Utilities.markFormGroupTouchedAndDirty(this.searchForm);
				}
			}
		);
		this.searchForm.updateValueAndValidity();
	}

	findCenters(): void {
		if (this.isSearchByAddress) {
			if (this.searchControl.invalid || !this.place) {
				this.searchControl.updateValueAndValidity();
				return;
			}
			this.searchCommoditiesByAddressAndModule();
		} else {
			this.searchForm.updateValueAndValidity({onlySelf: true});
			if (this.searchForm.invalid) {
				return;
			}
			this.searchCommoditiesByForm();
		}
	}

	addOrRemoveFindCenters(event: MatCheckboxChange, center: PlaceRepair): void {
		if (event.checked) {
			if (!this.onceSelectedPlaces.some(c => c === center)) {
				this.onceSelectedPlaces.push(center);
			}
			this.setCenter.emit(this.onceSelectedPlaces);
		}
	}

	addOrRemoveSelectedCenter(event: MatCheckboxChange, center: PlaceRepair): void {
		if (!event.checked) {
			this.onceSelectedPlaces = this.onceSelectedPlaces.filter(
				centerTemp => centerTemp.ald_commodity_id !== center.ald_commodity_id
			);
			this.setCenter.emit(this.onceSelectedPlaces);
		} else {

			if (this.onceSelectedPlaces.filter(
				centerTemp => centerTemp.ald_commodity_id === center.ald_commodity_id).length === 0
			) {
				this.onceSelectedPlaces.push(center);
			}
		}

	}

	isEntrySelected(ald_commodity_id: string): boolean {
		return this.onceSelectedPlaces.some(centerTemp => centerTemp.ald_commodity_id === ald_commodity_id);
	}

	private initPlaceAutocomplete(): void {
		this.mapsAPILoader.load().then(
			() => {
				this.autocomplete = new google.maps.places.Autocomplete(
					this.searchAddress.nativeElement,
					{}
				);

				this.autocomplete.setComponentRestrictions({country: 'it'});

				this.autocomplete.addListener('place_changed',
					() => {
						this.ngZone.run(
							() => {
								this.place = (
									!Utilities.isVoid(this.autocomplete.getPlace()) &&
									!Utilities.isVoid(this.autocomplete.getPlace().geometry) &&
									!Utilities.isVoid(this.autocomplete.getPlace().geometry.location)
								) ? (
									this.autocomplete.getPlace().geometry.location
								) : null;

								if (this.place === undefined || this.place === null) {
									this.searchControl.setErrors({ErrorSearch: true});
									this.formIsValid = false;
									this.places = [];
									return;
								} else {
									this.searchControl.setErrors(null);
									this.formIsValid = true;
								}
							}
						);
					}
				);
			}
		);

		this.searchControl.valueChanges.subscribe(
			() => {
				//to reset the place if i change the value
				this.place ? this.place = null : this.searchControl.setErrors({ErrorSearch: true});
			}
		);
	}

	select(): PlaceRepair[] {
		this.saveLoader = true;
		this.selectedcomodities = [];
		this.onceSelectedPlaces.forEach(
			commodity => {
				const place: CommodityModel = new CommodityModel();
				place.address = commodity.address;
				place.address_number = commodity.address_number;
				place.ald_commodity_id = +commodity.ald_commodity_id;
				place.ald_supplier_code = commodity.ald_supplier_code;
				place.province_code = commodity.province_code;
				place.distance = commodity.distance;
				place.lat = commodity.lat;
				place.lng = commodity.lng;
				place.fiscal_code = commodity.fiscal_code;
				place.center_id = commodity.center_id;
				place.phone = commodity.contact_phone;
				place.municipality = commodity.municipality;
				place.name = commodity.name;
				place.id = commodity.place_id;
				place.type_description = commodity.type;
				place.zip_code = commodity.zip_code;
				place.email = commodity.email;
				place.region = commodity.region;
				place.network_name = commodity.network_name;
				place.ald_supplier_id = commodity.ald_supplier_id;

				this.selectedcomodities.push(place);
			}
		);


		if (this.selectedcomodities.length > 1) {
			this.selectedcomodities.unshift(new CommodityModel({ald_commodity_id: CommodityModel.allCentersID}));
		}

		const itemMenuID: string = this.permissionService.getCurrentItemMenuId();
		this.currentUserPermission = this.permissionService.getCurrentUserPermissions();
		let module: string = this.moduleService.getCurrentModule(); // added for backend wrong response

		switch (itemMenuID) {
			case UserV3Model.USER_CHANGE_SP_MENU_ID:
				if (!this.moduleService.getCurrentUserModules().find(p => p === module)) {
					module = NemoModuleKeys.USER_CHNAGE_;
				}
				break;
			case UserV3Model.CONTRACT_CLOSING_SP_OP_ITEM_MENU_ID:
				if (!this.moduleService.getCurrentUserModules().find(p => p === module)) {
					module = NemoModuleKeys.CONTRACT_CLOSING_;
				}
				break;
			case UserV3Model.NOTIFICATION_CENTER_ITEM_MENU_ID:
				this.permissionService.getUserModules().forEach(
					m => {
						this.currentUserPermission.setCommoditiesForSuperUser(m, this.selectedcomodities);
					}
				);
				break;
			default:
				this.currentUserPermission.setCommoditiesForSuperUser(module, this.selectedcomodities);
				break;
		}

		const commands: string[] = [];
		this.selectComoditiesService.setCommodities(this.selectedcomodities, true);

		switch (itemMenuID) {
			case UserV3Model.AUTHORITY_ITEM_MENU_ID:
				commands.push(ROOT_AUTHORITY + '/' + AUTHORITY_DASHBOARD);
				break;
			case UserV3Model.CONTRACT_CLOSING_SP_OP_ITEM_MENU_ID:
				commands.push(ROOT_CONTRACT_CLOSING_SP + '/' + CCSPO_DASHBOARD);
				break;
			case UserV3Model.TYRES_ITEM_OPC_MENU_ID:
				commands.push(ROOT_TYRES + '/' + TYRES_OPC + '/' + TYRES_OPC_DASHBOARD);
				break;
			case UserV3Model.FLOTTA_POOL_MENU_ID:
				commands.push(ROOT_FLOTTA_POOL);
				break;
			case UserV3Model.USER_CHANGE_SP_MENU_ID:
				commands.push(ROOT_USER_CHANGE_SP + '/' + UC_DASHBOARD);
				break;
			case UserV3Model.INVOICING_ITEM_MENU_ID:
				commands.push(ROOT_INVOICING + '/' + INVOICING_DASHBOARD);
				break;
			case UserV3Model.NOTIFICATION_CENTER_ITEM_MENU_ID:
				commands.push(ROOT_NOTIFICATION_CENTER + '/' + NC_DASHBOARD);
				break;
			case UserV3Model.DELIVERY_ITEM_MENU_ID:
				commands.push(ROOT_DELIVERY + '/' + DL_DASHBOARD);
				break;
			case UserV3Model.LOGISTICS_ITEM_OPASR_MENU_ID:
				commands.push(ROOT_LOGISTICS + '/' + LOGISTICS_OPASR + '/' + LOGISTICS_OASR_DASHBOARD);
				break;
			/*case UserV3Model.BOOKINGS_RELIEF_MENU_ID:
				commands.push(ROOT_BOOKINGS_RELIEF + '/' + BookingsRoutingRoots.RESERVATION_LIST);
				break;*/
		}

		this.router.navigate(commands).then();
		this.saveLoader = false;
		return this.onceSelectedPlaces;
		//this.location.back();
	}

	private searchCommoditiesByAddressAndModule(): void {
		const moduleKey: NemoModuleKeys = this.permissionService.getCurrentModuleKey();

		if (!moduleKey) {
			return;
		}

		let lng: string;
		let lat: string;
		if (!Utilities.isVoid(this.place)) {
			lng = this.place.toJSON().lng.toFixed(2);
			lat = this.place.toJSON().lat.toFixed(2);
			this.showSearchLoader = true;
			this.permissionService.getCommoditiesByAddressForSuperUser(moduleKey, lat, lng, this.rangeSelected).pipe(
				catchError(
					err => {
						this.showSearchLoader = false;
						this.places = [];
						return throwError(err);
					}
				)
			).subscribe(
				commodities => {
					this.showSearchLoader = false;
					if (commodities && commodities.length) {
						this.places = commodities.map(center => this.getPlaceFromCommodity(center, lat, lng));

						if (this.moduleService.getCurrentModule() === Module.AUTHORITY) {
							const tempCommodities: PlaceRepair[] = [];
							this.places.forEach(
								item => {
									if (!tempCommodities.some(el => el.center_id === item.center_id)) {
										tempCommodities.push(item);
									}
								}
							);
							this.places = tempCommodities;
						}
					} else {
						this.places = [];
					}
				}
			);
		}
	}

	protected getPlaceFromCommodity(center: CommodityModel, lat?: string, lng?: string): PlaceRepair {
		const place: PlaceRepair = new PlaceRepair();
		place.address = center.address;
		place.address_number = center.address_number;
		place.ald_commodity_id = center.ald_commodity_id;
		place.ald_supplier_code = center.ald_supplier_code;
		place.contact_phone = center.phone;
		place.municipality = center.municipality;
		place.name = center.name;
		place.place_id = center.id;
		place.type = Place.TYPE_SERVICE_POINT;
		place.zip_code = center.zip_code;
		place.email = center.email;
		place.region = center.region;
		place.center_id = center.center_id;
		place.lat = lat;
		place.lng = lng;
		place.type_description = center.type_description;
		place.network_name = center.network_name;
		place.flag_delivery_point = center.flag_delivery_point;
		place.flag_return_point = center.flag_return_point;
		place.flag_premium_point = center.flag_premium_point;
		place.flag_base_ald = center.flag_base_ald;
		place.flag_service_box = center.flag_service_box;
		place.ald_supplier_id = center.ald_supplier_id;

		if (!Utilities.isVoid(center.distance)) {
			place.distance = Math.floor(center.distance) / 1000;
		}

		return place;
	}

	private searchCommoditiesByForm(): void {
		this.showSearchLoader = true;
		this.permissionService.getCommoditiesSuperUser(null, this.searchForm.getRawValue(), this.permissionService.getCurrentModuleKey()).pipe(
			catchError(
				err => {
					this.showSearchLoader = false;
					this.places = [];
					return throwError(err);
				}
			)
		).subscribe(
			commodities => {
				this.showSearchLoader = false;
				if (commodities && commodities.length) {
					this.places = commodities.map(center => this.getPlaceFromCommodity(center));
					if (this.moduleService.getCurrentModule() === Module.AUTHORITY) {
						const tempCommodities: PlaceRepair[] = [];
						this.places.forEach(
							item => {
								if (!tempCommodities.some(el => el.center_id === item.center_id)) {
									tempCommodities.push(item);
								}
							}
						);
						this.places = tempCommodities;
					}
				} else {
					this.places = [];
				}
			}
		);
	}
}
